import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {NodeApiService} from '../../../../services/api/network/online/node/node-api.service';
import {PeerConnectionApiService} from '../../../../services/api/peer-connection/peer-connection-api.service';

@Injectable({
  providedIn: 'root'
})
export class TestRouteService {

  constructor(private nodeApiService: NodeApiService,
              private pConApiService: PeerConnectionApiService) {
  }

  constructDataForTestRouteGrid(success, testRouteResult): void {
    if (testRouteResult.httpResponse !== 200 ||
      (_.isNil(testRouteResult.paths) &&
        (this.notDiscard(testRouteResult) && this.notContinue(testRouteResult)))) {
      testRouteResult.paths = [];
      testRouteResult.noRoutesFound = true;
      success(testRouteResult);
      return;
    }

    if (Array.isArray(testRouteResult.paths) && testRouteResult.paths.length > 0) {
        Promise.all([this.nodeApiService.getNodes(), this.pConApiService.getPCons()]).then(data => {
            const nodes = _.keyBy(data[0], 'id');
            const pCons = _.keyBy(data[1].elements, 'id');
            let selectedRulesCounter = 0;
            let unselectedRulesCounter = 0;
          testRouteResult.paths.forEach((path) => {
                if (path.discard) { return; }
                path.srcPeerConnection = testRouteResult.srcPeerConnection;
                path.destNodeName = nodes[path.destNode].name;

                if (path.destPeerConnection !== -1) {
                    path.destPeerConnectionName = pCons[path.destPeerConnection].name;
                }

                path.routingRuleName = path.rrName;
                path.routingGroupName = path.rrGroupName;
                path.numOfEdges = path.edges !== null ?
                    path.edges.length : 0;
                path.discarded = false;
                if (!path.unselectedRule) {
                  selectedRulesCounter++;
                  path.path = 'path ' + (selectedRulesCounter);
                }
                else{
                  unselectedRulesCounter++;
                  path.path = 'Unselected Path ' + (unselectedRulesCounter);
                }
            });

            this.updateDiscardAndContinue(testRouteResult);
            success(testRouteResult);
        });
    } else {
        this.updateDiscardAndContinue(testRouteResult);
        success(testRouteResult);
    }
  }

  constructTestRouteData(success, testRoute): void {
    Promise.all([this.nodeApiService.getNode(testRoute.srcNode), this.pConApiService.getPcon(testRoute.srcPeerConnection)]).then(data => {
      testRoute.srcNodeName = data[0].name;
      testRoute.srcPeerConnectionName = data[1].name;
      success(testRoute);
    });

  }

  constructDataForTestRouteDetailsGrid(testRouteResult, selectedPaths): any {
    const result = [];

    const buildTestRouteManipulationRecord = (manipulation, manipulationInner, manipulationType) => {
      const changedTemplateClasses = ['blue-text-color', 'bold-text'];
      return {
        color: manipulationInner.changed ? changedTemplateClasses : [],
        manipulationType,
        manipulatedEntity: manipulation.manipulatedEntity === null ? '' : manipulation.manipulatedEntity,
        manipulatingEntity: manipulationInner.manipulatingEntityName,
        usingManipulatingEntity: manipulationInner.usingManipulatingEntityName === null ? '' :
          manipulationInner.usingManipulatingEntityName,
        originalValue: manipulationInner.originalValue === null ? '' : manipulationInner.originalValue,
        manipulatedValue: manipulationInner.manipulatedValue === null ? '' : manipulationInner.manipulatedValue,
        unselectedRuleDescription: manipulationInner.unselectedRuleDescription === null ? '' : manipulationInner.unselectedRuleDescription,
        usedInRouting: manipulationInner.unselectedRule === null ? 'Yes' : (!manipulationInner.unselectedRule ? 'Yes' : 'No')
      };
    };

    if (testRouteResult && testRouteResult.preRouteManipulationsList != null) {
      testRouteResult.preRouteManipulationsList.forEach((manipulation) => {
        manipulation.manipulationsList.forEach((innerManipulation) => {
          const preManipulationRecord = buildTestRouteManipulationRecord(manipulation, innerManipulation, 'Before route');
          result.push(preManipulationRecord);
        });
      });
    }

    if (selectedPaths && selectedPaths.length > 0) {
      const selectedPath = selectedPaths[0];
      const pathRouteManipulationsList = selectedPath.pathRouteManipulationsList;
      if (pathRouteManipulationsList) {
        pathRouteManipulationsList.forEach((manipulation) => {
          manipulation.manipulationsList.forEach((innerManipulation) => {
            const pathManipulationRecord = buildTestRouteManipulationRecord(manipulation, innerManipulation, 'During route');
            result.push(pathManipulationRecord);
          });
        });
      }
    }
    return result;
  }

    private updateDiscardAndContinue(testRouteResult): void {
        if (testRouteResult.discardingByRoutingRule !== -1) {
            const pathIndex = testRouteResult.paths !== null && testRouteResult.paths.length > 0 ? testRouteResult.paths.length : 0;
            const pathRecord = {
                routingRuleName: testRouteResult.discardingByRrName,
                routingGroupName: testRouteResult.discardingByRrGroupName,
                numOfEdges: 'Discarded',
                path: 'path ' + (pathIndex + 1),
                discarded: true
            };

            if (testRouteResult.paths === null) {
                testRouteResult.paths = [];
            }

            testRouteResult.paths.push(pathRecord);
        }

        if (testRouteResult.continueWithNodeInternalTablesByRoutingRule !== -1) {
            const pathIndex = testRouteResult.paths !== null && testRouteResult.paths.length > 0 ? testRouteResult.paths.length : 0;
            const pathRecord: any = {
                routingRuleName: testRouteResult.continueWithNodeInternalTablesgByRrName,
                routingGroupName: testRouteResult.continueWithNodeInternalTablesByRrGroupName,
                numOfEdges: 'Continue',
                path: 'path ' + (pathIndex + 1),
                destNode: testRouteResult.srcNode,
                destPeerConnection: testRouteResult.srcPeerConnection,
                discarded: false,
                edges: null
            };

            if (testRouteResult.paths === null) {
                testRouteResult.paths = [];
            }

            testRouteResult.paths.push(pathRecord);
        }
    }

    private notDiscard(testRouteResult): boolean {
        return (_.isNil(testRouteResult.discardingByRoutingRule) || testRouteResult.discardingByRoutingRule === -1) &&
            _.isNil(testRouteResult.discardingByRrGroupName) &&
            _.isNil(testRouteResult.discardingByRrName);
    }

  private notContinue(testRouteResult): boolean {
    return (_.isNil(testRouteResult.continueWithNodeInternalTablesByRoutingRule) || testRouteResult.continueWithNodeInternalTablesByRoutingRule === -1) &&
      _.isNil(testRouteResult.continueWithNodeInternalTablesByRrGroupName) &&
      _.isNil(testRouteResult.continueWithNodeInternalTablesgByRrName);
  }
}
